module.exports = __webpack_public_path__ + "img/L-头.233ae535.png";